import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'
import { SplitTextRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'
import { CmsCtaButtonRebrand } from 'src/components/molecules/CmsCtaButtonRebrand'
import { Text, TextValue } from 'src/components/molecules/sanity/Content'

// Note: design spec calls for background #fbf7f3, but it doesn't exist in the palette.
// Using `linen` (#F9F5F0) as the closest available token.
// Spec body/heading color #1d4321 is also missing — using `forestDeep` (#08441B) as the
// closest available token (palette updated since spec was authored).

type ColumnSide = 'left' | 'right'

type ColumnProps = {
  side: ColumnSide
  eyebrow?: string
  eyebrowColumn: ColumnSide
  heading?: string
  headingColumn: ColumnSide
  headingInColumn: boolean
  body?: TextValue
  button?: JSX.Element | null
  buttonColumn: ColumnSide
}

const Column = ({
  side,
  eyebrow,
  eyebrowColumn,
  heading,
  headingColumn,
  headingInColumn,
  body,
  button,
  buttonColumn
}: ColumnProps) => (
  <div className='flex flex-1 flex-col items-start gap-2'>
    {eyebrow && eyebrowColumn === side && (
      <TypographyRebrand color='forestDeep' variant='eyebrow'>
        {eyebrow}
      </TypographyRebrand>
    )}
    {heading && headingInColumn && headingColumn === side && (
      <TypographyRebrand color='forestDeep' variant='h4'>
        {heading}
      </TypographyRebrand>
    )}
    {body && (
      <TypographyRebrand color='forestDeep' variant='introduction'>
        <Text
          components={{
            block: ({ children }) => (
              <p className='mb-4 last:mb-0'>{children}</p>
            )
          }}
          value={body}
        />
      </TypographyRebrand>
    )}
    {button && buttonColumn === side && button}
  </div>
)

const SplitTextSectionRebrand = ({
  layout,
  eyebrow,
  heading,
  headingColumn = 'left',
  leftBody,
  rightBody,
  buttons,
  buttonColumn = 'right',
  eyebrowColumn = 'right'
}: SplitTextRebrandResult) => {
  const button = buttons?.[0]
  const renderedButton = button ? <CmsCtaButtonRebrand {...button} /> : null
  const headingInColumn = layout === 'headingInColumn'

  const sharedColumnProps = {
    eyebrow,
    eyebrowColumn,
    heading,
    headingColumn,
    headingInColumn,
    button: renderedButton,
    buttonColumn
  }

  return (
    <div className='bg-linen py-6'>
      <div className='container mx-auto px-4 lg:px-20'>
        {heading && !headingInColumn && (
          <TypographyRebrand color='forestDeep' variant='h4'>
            {heading}
          </TypographyRebrand>
        )}
        <div
          className={`flex flex-col gap-4 lg:flex-row lg:items-start lg:gap-6 ${
            heading && !headingInColumn ? 'mt-6' : ''
          }`}
        >
          <Column side='left' body={leftBody} {...sharedColumnProps} />
          <Column side='right' body={rightBody} {...sharedColumnProps} />
        </div>
      </div>
    </div>
  )
}

export default SplitTextSectionRebrand
export { SplitTextSectionRebrand }
